module.exports = __webpack_public_path__ + "media/images/Group 18-b6f5b62017a675392f24a4887357313a.png";